import script from "./TableEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableEdit.vue?vue&type=script&setup=true&lang=ts"

import "./TableEdit.vue?vue&type=style&index=0&id=30778d06&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30778d06"]])

export default __exports__